import { forwardRef, HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  disabled?: boolean
} & HTMLAttributes<HTMLDivElement>

export const CalculationEditor = forwardRef<HTMLDivElement, Props>(
  ({ className, disabled, ...props }, ref) => (
    <div
      contentEditable
      className={cn(
        'min-h-64 overflow-auto rounded-none p-2.5 !outline-blue-200',
        'relative focus:!border-blue-200 active:!border-blue-200',

        'empty:before:content-["Click_to_start_typing"]',
        'empty:before:text-gray-300',
        '[&>div]:align-middle',

        '[&>div]:inline-block [&>div]:w-[fit-content] [&>div]:px-0.5 [&>div]:py-1',
        '[&>div]:mb-1 [&>div]:mr-0.5',
        '[&>div]:select-none',

        '[&>div[data-type="operator"]]:text-base [&>div[data-type="operator"]]:font-bold [&>div[data-type="operator"]]:text-primary',
        '[&>div[data-type="parentheses"]]:font-bold [&>div[data-type="parentheses"]]:text-primary',

        '[&>div[data-type="field"]]:inline-block [&>div[data-type="field"]]:rounded',
        '[&>div[data-type="field"]]:border [&>div[data-type="field"]]:bg-primary/80',
        '[&>div[data-type="field"]]:border-primary/95 [&>div[data-type="field"]]:text-white',
        '[&>div[data-type="field"]]:cursor-default [&>div[data-type="field"]]:text-base',
        '[&>div[data-type="field"]]:truncate [&>div[data-type="field"]]:text-center',
        '[&>div[data-type="field"]]:w-[100px] [&>div[data-type="field"]]:py-0.5',
        '[&>div[data-type="field"].removed-field]:bg-[#e53e3e]',
        '[&>div[data-type="field"].removed-field]:border-[#c53030]',

        '[&>div[data-type="function"]]:inline-block [&>div[data-type="function"]]:rounded',
        '[&>div[data-type="function"]]:border [&>div[data-type="function"]]:bg-purple-800/80',
        '[&>div[data-type="function"]]:border-purple-700 [&>div[data-type="function"]]:text-white',
        '[&>div[data-type="function"]:hover]:bg-purple-800/75 [&>div[data-type="function"]]:cursor-pointer [&>div[data-type="function"]]:text-base',
        '[&>div[data-type="function"]]:truncate [&>div[data-type="function"]]:text-center',
        '[&>div[data-type="function"]]:w-[116px] [&>div[data-type="function"]]:px-1 [&>div[data-type="function"]]:py-0.5',

        '[&[contenteditable="true"]]:contain-content [&_div[contenteditable="true"]]:contain-content',

        {
          '[&>*]:pointer-events-none [&>*]:select-none [&>*]:opacity-70':
            disabled,
        },
        className
      )}
      ref={ref}
      {...props}
    />
  )
)
